import { default as calculationcbqHxJauDsMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/layers/travel/pages/calculation.vue?macro=true";
import { default as detailjm3KR4b8lbMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/layers/travel/pages/detail.vue?macro=true";
import { default as inquiryR5HIlN2HgqMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue?macro=true";
import { default as _91_91type_93_93FxYjIkVrymMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue?macro=true";
import { default as offer_45listZDslpb4dnIMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue?macro=true";
import { default as testingN1GjdOanaZMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/pages/testing.vue?macro=true";
import { default as thankyou1V05ZBgufiMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue?macro=true";
import { default as upsellpdSFmvdlDWMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/layers/travel/pages/upsell.vue?macro=true";
import { default as zadost26JY8VhHkrMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost?macro=true";
import { default as thankuw3cEICGMoMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank?macro=true";
import { default as srovnani6XKaanOhpfMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani?macro=true";
import { default as page6ziYRoBfLIMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page?macro=true";
import { default as headers_45testhX5H0LbwfKMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test?macro=true";
import { default as homepagej3hiw3cMosMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage?macro=true";
import { default as articleKLPSlbx95vMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article?macro=true";
import { default as document_45patternsZRv4UG6bBWMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns?macro=true";
import { default as tagE9i3u2gK1gMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag?macro=true";
import { default as autorWseKmZOegAMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor?macro=true";
import { default as categoryPlO9hcMuqGMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category?macro=true";
import { default as section61qUpaAx16Meta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section?macro=true";
import { default as all_45articlesvrlwsF4mTZMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles?macro=true";
import { default as categoryM1MkqxJXZxMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category?macro=true";
import { default as articleJ9wzcPPgTjMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article?macro=true";
import { default as section6bQJc9UGL3Meta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section?macro=true";
import { default as contactiHqoPpeDomMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact?macro=true";
import { default as car_45insurance_45terminationGL9IxML0wpMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination?macro=true";
import { default as calculationknNYQMtNqAMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation?macro=true";
import { default as thank_45you2cLLr6VOhTMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you?macro=true";
import { default as detailD8coGEJO3QMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail?macro=true";
import { default as inquiryV5LHANJhNwMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry?macro=true";
import { default as offer_45listS9JBosEF0iMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list?macro=true";
import { default as calculationFiTWI73i1pMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation?macro=true";
import { default as thank_45youyx2PU0rPJnMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you?macro=true";
import { default as inquiryZ59Yaw2cEGMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry?macro=true";
import { default as offer_45listl3NcqwaWGxMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list?macro=true";
import { default as detailumGqykQDi3Meta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail?macro=true";
import { default as offermNdiAexI58Meta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer?macro=true";
import { default as inquiryYYrJ2HvVSqMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry?macro=true";
import { default as thank_45youYxeUEwPHW5Meta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you?macro=true";
import { default as calculationzDgH73coq0Meta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation?macro=true";
import { default as offer_45listr2temounPWMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list?macro=true";
import { default as thank_45youz6JjWNcn3YMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you?macro=true";
import { default as inquiry_45onlineMfZmqQAYp9Meta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online?macro=true";
import { default as detailzKvlIdyLvEMeta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/energo/pages/detail?macro=true";
import { default as inquiry_45phoneJPg75mIYA7Meta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone?macro=true";
import { default as inquiry_45custom_45offervWfICPzlZ2Meta } from "/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer?macro=true";
export default [
  {
    name: "calculation",
    path: "/cestovni-pojisteni/zadani-ab/:leadId?",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/layers/travel/pages/calculation.vue")
  },
  {
    name: "detail",
    path: "/cestovni-pojisteni/:leadId?/detail/:offerId?",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/layers/travel/pages/detail.vue")
  },
  {
    name: "inquiry",
    path: "/cestovni-pojisteni/sjednani/:leadId?",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue")
  },
  {
    name: "kurzy-company-type",
    path: "/kurzy/:company?/:type?",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue")
  },
  {
    name: "offer-list",
    path: "/cestovni-pojisteni/nabidka/:leadId?",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue")
  },
  {
    name: "testing",
    path: "/testing",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/pages/testing.vue")
  },
  {
    name: "thankyou",
    path: "/cestovni-pojisteni/dekujeme/:leadId?",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue")
  },
  {
    name: "upsell",
    path: "/cestovni-pojisteni/upsell/:leadId?",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/layers/travel/pages/upsell.vue")
  },
  {
    name: zadost26JY8VhHkrMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/zadost",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost")
  },
  {
    name: thankuw3cEICGMoMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/:thank(dekujeme|zamitnuto-partner|zamitnuto)",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank")
  },
  {
    name: srovnani6XKaanOhpfMeta?.name,
    path: "/pujcky-a-uvery/pujcka-na-miru/srovnani",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani")
  },
  {
    name: page6ziYRoBfLIMeta?.name,
    path: "/:all(.*)*",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: headers_45testhX5H0LbwfKMeta?.name,
    path: "/headers-test",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test")
  },
  {
    name: homepagej3hiw3cMosMeta?.name,
    path: "/clanky",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage")
  },
  {
    name: articleKLPSlbx95vMeta?.name,
    path: "/clanky/:article(.*)*",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article")
  },
  {
    name: document_45patternsZRv4UG6bBWMeta?.name,
    path: "/clanky/vzory-dokumentu",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns")
  },
  {
    name: tagE9i3u2gK1gMeta?.name,
    path: "/clanky/tag/:slug(.*)*",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag")
  },
  {
    name: autorWseKmZOegAMeta?.name,
    path: "/clanky/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor")
  },
  {
    name: categoryPlO9hcMuqGMeta?.name,
    path: "/clanky/:category(kategorie)",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category")
  },
  {
    name: section61qUpaAx16Meta?.name,
    path: "/clanky/:category(kategorie)/:section(pojisteni|hypoteky|pujcky|energie|mobilni-tarify|osobni-finance)",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section")
  },
  {
    name: all_45articlesvrlwsF4mTZMeta?.name,
    path: "/clanky/all-articles",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles")
  },
  {
    name: page6ziYRoBfLIMeta?.name,
    path: "/slovnik-pojmu",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: categoryM1MkqxJXZxMeta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category")
  },
  {
    name: articleJ9wzcPPgTjMeta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)/:id(.*)*",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article")
  },
  {
    name: section6bQJc9UGL3Meta?.name,
    path: "/radce/",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: section6bQJc9UGL3Meta?.name,
    path: "/radce/:slug(.*)",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: contactiHqoPpeDomMeta?.name,
    path: "/kontakt",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact")
  },
  {
    name: car_45insurance_45terminationGL9IxML0wpMeta?.name,
    path: "/zruseni-povinneho-ruceni-zmena-pojistovny",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination")
  },
  {
    name: calculationknNYQMtNqAMeta?.name,
    path: "/internet/kalkulace",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation")
  },
  {
    name: thank_45you2cLLr6VOhTMeta?.name,
    path: "/internet/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you")
  },
  {
    name: detailD8coGEJO3QMeta?.name,
    path: "/internet/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail")
  },
  {
    name: inquiryV5LHANJhNwMeta?.name,
    path: "/internet/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry")
  },
  {
    name: offer_45listS9JBosEF0iMeta?.name,
    path: "/internet/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list")
  },
  {
    name: calculationFiTWI73i1pMeta?.name,
    path: "/mobilni-tarify/kalkulace",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation")
  },
  {
    name: thank_45youyx2PU0rPJnMeta?.name,
    path: "/mobilni-tarify/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you")
  },
  {
    name: inquiryZ59Yaw2cEGMeta?.name,
    path: "/mobilni-tarify/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry")
  },
  {
    name: offer_45listl3NcqwaWGxMeta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list")
  },
  {
    name: detailumGqykQDi3Meta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail")
  },
  {
    name: offermNdiAexI58Meta?.name,
    path: "/balicky-sluzeb/priklad-nabidky",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer")
  },
  {
    name: inquiryYYrJ2HvVSqMeta?.name,
    path: "/balicky-sluzeb/sjednani-nabidky",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry")
  },
  {
    name: thank_45youYxeUEwPHW5Meta?.name,
    path: "/balicky-sluzeb/potvrzeni-objednavky",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you")
  },
  {
    name: calculationzDgH73coq0Meta?.name,
    path: "/energie/kalkulace-:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation")
  },
  {
    name: offer_45listr2temounPWMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list")
  },
  {
    name: thank_45youz6JjWNcn3YMeta?.name,
    path: "/energie/prehled-vaseho-pozadavku/:leadId?",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you")
  },
  {
    name: inquiry_45onlineMfZmqQAYp9Meta?.name,
    path: "/energie/sjednani-online/:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online")
  },
  {
    name: detailzKvlIdyLvEMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId/detail/:tariffId",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/energo/pages/detail")
  },
  {
    name: inquiry_45phoneJPg75mIYA7Meta?.name,
    path: "/energie/sjednani-po-telefonu/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone")
  },
  {
    name: inquiry_45custom_45offervWfICPzlZ2Meta?.name,
    path: "/energie/nabidka-na-miru",
    component: () => import("/codebuild/output/src2934004131/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer")
  }
]